import {
  AlphamapBrandLogo,
  BrandLogoResponse,
  BrandLogosInRadiusRequest,
  BrandLogosInRadiusResponse,
} from 'src/common-services/types/brand-logo-types'
import { BaseClient } from 'src/common-services/clients/base-client'
import { TenantFinderBrandListMap } from 'src/types/tenant-finder'

export class BrandLogosClient extends BaseClient {
  getBrandLogos(char: string): Promise<BrandLogoResponse> {
    return this.call<BrandLogoResponse>('/brand-logos', 'GET', {
      params: {
        char,
      },
    })
  }

  updateBrandLogos(brandId: string, brand: string, url: string): Promise<any> {
    return this.call('/brand-logos', 'PUT', { data: { brandId, brand, url } })
  }

  uploadBrandLogo(brandId: string, brand: string, url: string): Promise<any> {
    return this.call(`/brand-logos/${brandId}`, 'POST', { data: { brandId, brand, url } })
  }

  deleteBrandLogo(brandId: string, brand: string, s3Key: string): Promise<any> {
    return this.call(`/brand-logos/${brandId}`, 'DELETE', { data: { brandId, brand, s3Key } })
  }

  getAllBrandLogos(): Promise<AlphamapBrandLogo[]> {
    return this.call<AlphamapBrandLogo[]>('/brand-logos/all', 'GET')
  }

  getUniqueBrandLogos(): Promise<AlphamapBrandLogo[]> {
    return this.call<AlphamapBrandLogo[]>('/brand-logos/unique', 'GET')
  }

  getYelpBrandLogos(char: string): Promise<BrandLogoResponse> {
    return this.call<BrandLogoResponse>('/brand-logos/yelp', 'GET', {
      params: {
        char,
      },
    })
  }

  getTenantFinderBrandLogos(): Promise<TenantFinderBrandListMap> {
    return this.call<TenantFinderBrandListMap>('/experimental/tenant-finder/brands', 'GET')
  }

  getAlphamapBrandLogoById(id: string): Promise<{
    logoUrl: string | undefined
  }> {
    return this.call<{
      logoUrl: string | undefined
    }>(`/brand-logos/alphamap/${id}`, 'GET')
  }

  getAlphamapBrandLogosInRadius(request: BrandLogosInRadiusRequest): Promise<BrandLogosInRadiusResponse> {
    return this.call<BrandLogosInRadiusResponse>(`/brand-logos/in-radius`, 'POST', { data: request })
  }
}
